import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const endpoints = {
  config: () => api.get("/config").then((r) => r.data),
  roll: (boothId) => api.get(`/roll/${boothId}`).then((r) => r.data),
  verifyOfficers: (data) => api.post("/officers/verify", data).then((r) => r.data),
  openBooth: (data) => api.post("/booth/open", data).then((r) => r.data),
  closeBooth: (data) => api.post("/booth/close", data).then((r) => r.data),
  syncEvents: (data) => api.post("/sync/events", data).then((r) => r.data),
  syncStatus: () => api.get("/sync/status").then((r) => r.data),
  booths: () => api.get("/booths").then((r) => r.data),
  results: () => api.get("/results").then((r) => r.data),
  incidents: () => api.get("/incidents").then((r) => r.data),
  createIncident: (data) => api.post("/incidents", data).then((r) => r.data),
  auditCases: () => api.get("/audit/cases").then((r) => r.data),
  openAuditCase: (data) => api.post("/audit/cases", data).then((r) => r.data),
  events: (boothId) => api.get(`/events/${boothId}`).then((r) => r.data),
  allEvents: () => api.get("/events").then((r) => r.data),
  injectTamper: (data) => api.post("/test/inject", data).then((r) => r.data),
  tampers: () => api.get("/test/tampers").then((r) => r.data),
  reset: () => api.post("/test/reset").then((r) => r.data),
};
